import React, { useEffect, useRef, useState } from 'react'
import "../styleCss/UserManage.css"
import Header from "../../template/Header.js";
import Menu from "../../template/Menu.js";
import Footer from "../../template/Footer.js";
import Swal from "sweetalert2";
import axios from "axios";
import Loading from "../../components/loading/Loading";
import { setTimeOutSync } from "../../utils/setTimeout";
import { Col, Row } from "react-bootstrap";
import Dropdown from "../../components/dropdowns/Dropdown.js"
import { getRole } from "../../api/role_api.js";
import { getAdminByID, updateAdminByID, createAdmin } from "../../api/admin_api.js";
import {
  textSearchBtn,
  textResetBtn,
  textCreateBtn,
  colorSearchBtn,
  colorResetBtn,
  colorCreateBtn,
  iconSearchBtn,
  iconResetBtn,
  iconCreateBtn,
  hoverSearchBtn,
  hoverResetBtn,
  hoverCreateBtn,
  textSaveBtn,
  textCancleBtn,
  colorSaveBtn,
  colorCancleBtn,
  hoverSaveBtn,
  hoverCancleBtn,
  colorEditBtns,
  hoverEditBtns
} from "../../components/ThemeConfig/btnConfig.js";
import { useButtonDynamicStyles } from "../../components/useDynamic/Button_DynamicStyle.js";
import { useNavigate } from 'react-router-dom';
import {
  alertValidateData,
  alertKeySpaceBar,
  alertKeyLangTH,
  alertConfirmSave,
  alertSaved,
  alertCancel,
  alertErrorExistsUsernameOrEmail,
  alertIncorrectEmail
} from "../../components/alertValid/AlertValid.js"

function AddEditUser() {
  useButtonDynamicStyles(
    textSearchBtn,
    textResetBtn,
    textCreateBtn,
    colorSearchBtn,
    colorResetBtn,
    colorCreateBtn,
    iconSearchBtn,
    iconResetBtn,
    iconCreateBtn,
    hoverSearchBtn,
    hoverResetBtn,
    hoverCreateBtn,
    textSaveBtn,
    textCancleBtn,
    colorSaveBtn,
    colorCancleBtn,
    hoverSaveBtn,
    hoverCancleBtn,
    colorEditBtns,
    hoverEditBtns
  );

  const [isLoading, setLoading] = useState(false);
  const [txtTitleId, setTxtTitleId] = useState();
  const [editId, setEditId] = useState(null);
  const [active, setActive] = useState(true);

  const [inputForm, setInputForm] = useState({
    role: 0,
  });

  const [dataUser, setDataUser] = useState({
    username: null,
    firstname: null,
    lastname: null,
    email: null,
    tel: null
  });

  const [valuefromparent1, setValuefromparent1] = useState("--- please select ---");
  const [selectedRole, setSelecteRole] = useState("");
  const [DataDropRole, setDataDropRole] = useState([]);

    function setinput(inputname, value) {
      setInputForm((prev) => {
        return {
          ...prev,
          [inputname]: value,
        };
      });
    }

    const handleRoleChange = (value) => {
        setSelecteRole(value);
    };

    const ChangesetValuefromparent1 = (text) =>  {
        setValuefromparent1(text);
    }

    const getRoleDropDown = async () => {
      try {
          const response = await getRole();
          if (response.status == 200) {
              let dataRole = [];
              response.data.data.forEach((item, i) => {
                  return dataRole.push({
                      value: item._id,
                      text: item.role_name,
                  });
              });
              let id = new URLSearchParams(window.location.search).get("id");
              if(dataRole.length>0 && id){
                setValuefromparent1(dataRole[0].text);// set ตัวหนังสือของ dropdown
                setInputForm('role',dataRole[0].value)//เซ็ทค่าของ id ตัวแรก ให้กับ state ที่ใช้ส่ง api
              }
              setDataDropRole(dataRole);
          }
      } catch (error) {
          console.log(error);
      }
    };

    const alertValidate = async () => {
      const result = await alertValidateData();
          if (result.isConfirmed) {
              return;
          } else {
              return;
          }
  }

  const getDataAdminID = async (id) => {
    await setLoading(true);
    const respon = await getAdminByID(id);
    setTimeout(async () => {
      await setLoading(false);
    }, 1000);

    let dataPreview = respon.data.data;

    setDataUser({
      ...dataUser,
      username: dataPreview.username ? dataPreview.username : null,
      firstname: dataPreview.firstname ? dataPreview.firstname : null,
      lastname: dataPreview.lastname ? dataPreview.lastname : null,
      email: dataPreview.email ? dataPreview.email : null,
      tel: dataPreview.mobile_no ? dataPreview.mobile_no : null,
      status: dataPreview.active === 1 ? "ใช้งาน" : "ไม่ใช้งาน",
    });
    setActive(dataPreview.active === 1 ? true : false);
    setSelecteRole(dataPreview.role)
  };

  const createAdminData = async () => {
    try {
      let body = {
        username: dataUser.username,
        firstname: dataUser.firstname,
        lastname: dataUser.lastname,
        role: selectedRole,
        email: dataUser.email,
        mobile_no: dataUser.tel,
        active: active === false ? 0 : 1,
      };
      if (
        !body.username ||
        !body.firstname ||
        !body.lastname ||
        !body.email ||
        !body.role ||
        !body.mobile_no ||
        body.mobile_no.length !== 10
      ) {
        await alertValidate();
      } else {
        const result = await alertConfirmSave();
          if (result.isConfirmed) {
           
              await setLoading(true);
              const parseLowerEmail = body?.email?.toLowerCase()
              const response = await createAdmin({...body, email: parseLowerEmail});
               setLoading(false)
              if (response.data.status == "success") {
                const result = await alertSaved();
                  if (result.isConfirmed) {
                    navigateToBack("/infoUserManage");
                  }
              }
               setLoading(false)
            }
          }
    } catch (error) {
      console.log(`error in try catch`, error)
      setLoading(false)
      await alertErrorExistsUsernameOrEmail()
    }
    setLoading(false)
    
  };

  const updateAdmin = async (id) => {
    try {
      let body = {
        username: dataUser.username,
        firstname: dataUser.firstname,
        lastname: dataUser.lastname,
        role: selectedRole,
        email: dataUser.email,
        mobile_no: dataUser.tel,
        active: active === false ? 0 : 1,
      };
      if (
        !body.username ||
        !body.firstname ||
        !body.lastname ||
        !body.email ||
        !body.role ||
        !body.mobile_no ||
        body.mobile_no.length !== 10
      ) {
        await alertValidate();
      } else {
        const result = await alertConfirmSave();
          if (result.isConfirmed) {
            await setLoading(true);
            const parseLowerEmail = body?.email?.toLowerCase()
            const response = await updateAdminByID(id, {...body, email: parseLowerEmail});
            setLoading(false) 
              if (response.data.status == "success") {
                const res = await alertSaved();
                  if (res.isConfirmed) {
                    navigateToBack("/infoUserManage");
                  }
              }
            setLoading(false)
          }
      }
    } catch (error) {
      console.log(`error in try catch`, error)
      setLoading(false)
      await alertErrorExistsUsernameOrEmail()
    }
    setLoading(false)
  };

  const handleInputChkThai = async (event) => {
    const thaiCharacterRegex = /[\u0E00-\u0E7F]/; // Thai character Unicode range
    if (event.target.value.includes(' ')) {
      event.target.value = event.target.value.replace(/\s/g, ''); // Remove spaces
      await alertKeySpaceBar();
      return;
    }

    if (thaiCharacterRegex.test(event.target.value)) {
      event.target.value = ""; // Clear input if it contains Thai characters
      await alertKeyLangTH();
      return;
    }
  };

  const validateEmail = async (email) => {
    // Regular expression for email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
        await alertIncorrectEmail();
        return false;
    }
    return true;
  }

  const handleActiveBtn = async () => {
    if (!await validateEmail(dataUser.email)) {
        return;
    }

    let id = new URLSearchParams(window.location.search).get("id");
    if (id) {
        updateAdmin(id);
    } else {
        createAdminData();
    }
  };

  const navigate = useNavigate();
  const navigateToBack = (page) => {
    navigate(page);
  };

  const handleClickCancel = async () => {
    const res = await alertCancel();
        if (res.isConfirmed) {
          navigateToBack("/infoUserManage");
        }
        else { }
  };

  let apiCalled = useRef(false); // Flag variable

  useEffect(() => {
    if (!apiCalled.current) {
      apiCalled.current = true;
      let id = new URLSearchParams(window.location.search).get("id");
      if (id) {
        getDataAdminID(id);
        setEditId(id);
        setTxtTitleId(id);
      }
    };
    getRoleDropDown();
  }, [apiCalled.current]);

  return (
    <>
      <style>
        {`
        .select {
          width: 100% !important;
          height: 42px !important;
          border: 1px solid #D1D3D4 !important;
          border-radius: .25rem !important;
          padding: 10px 5px !important;
        }
        
        .ic-dropdown {
            width: 23px !important;
            padding: 5px !important;
        }
        
        .options-list {
          width: 96% !important;
          border-radius: 6px;
        }

        @media (min-height: 788px) { 
          .pdb-page {
              padding-bottom: calc(19rem + 1px) !important;
          }
        }

      `}
      </style>
      {isLoading ? <Loading /> : ""}
      <Header parentmenu={"ADMIN USER"} />
      <Menu
        parentmenu={"infoAdminUser"}
        activemenu={"infoUserManage"}
      />
      <div className="content-wrapper">
        <div className="container-fluid pdb-page">
          <div className="box-white">
            <Row>
              <Col xs={12}>
                {txtTitleId ? (
                  <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                    <img src="assets/icons/ic-users.png" className="ic-user01 me-2" alt="" />
                    EDIT ADMIN USER
                  </font>
                ) : (
                  <font className="font-size07 colorBlack01 fontBold d-flex align-items-center">
                    <img src="assets/icons/ic-users.png" className="ic-user01 me-2" alt="" />
                    ADD ADMIN USER
                  </font>
                )}
              </Col>
            </Row>
            <Row className="ms-5">
              <Col xs={12} className="d-flex align-items-center mt-3 p-0">
                {editId ? (
                  <p className="mb-0 font-weight-bold fontReg font-size01">
                    Edit Admin User
                  </p>
                ) : (
                  <p className="mb-0 font-weight-bold fontReg font-size01">
                    Add Admin User
                  </p>
                )}
              </Col>
            </Row>
            <Row className="ms-5 mt-3 d-flex align-items-center">
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Username <span className=' colorRed'>*</span>
                </label>
              </Col>
              <Col xs={9} xl={5}>
                <input
                  type="text"
                  className="inp01 fontLight font-size03"
                  id="username"
                  placeholder="Username"
                  value={dataUser.username}
                  onChange={(event) =>
                    setDataUser({
                      ...dataUser,
                      username: event.target.value,
                    })
                  }
                  disabled={editId ? true : false}
                />
              </Col>
            </Row>
            <Row className="ms-5 mt-3 d-flex align-items-center">
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Firstname <span className=' colorRed'>*</span>
                </label>
              </Col>
              <Col xs={9} xl={5}>
                <input
                  type="text"
                  className="inp01 fontLight font-size03"
                  id="firstname"
                  placeholder="Firstname"
                  value={dataUser.firstname}
                  onChange={(event) =>
                    setDataUser({
                      ...dataUser,
                      firstname: event.target.value,
                    })
                  }
                />
              </Col>
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Lastname <span className=' colorRed'>*</span>
                </label>
              </Col>
              <Col xs={9} xl={5}>
                <input
                  type="text"
                  className="inp01 fontLight font-size03"
                  id="lastname"
                  placeholder="Lastname"
                  value={dataUser.lastname}
                  onChange={(event) =>
                    setDataUser({
                      ...dataUser,
                      lastname: event.target.value,
                    })
                  }
                />
              </Col>
            </Row>
            <Row className="ms-5 mt-3 d-flex align-items-center">
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Role <span className=' colorRed'>*</span>
                </label>
              </Col>

              <Col xs={9} xl={5}>
                <Dropdown
                  options={DataDropRole}
                  setinput={setinput}
                  inputname={"role"}
                  ChangesetValuefromparent={ChangesetValuefromparent1}
                  valuefromparent={DataDropRole.find((item => item.value === selectedRole)) ? DataDropRole.find((item => item.value === selectedRole)).text : valuefromparent1}
                  onChange={handleRoleChange}
                />
              </Col>
            </Row>
            <Row className="ms-5 mt-3 d-flex align-items-center">
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Email <span className=' colorRed'>*</span>
                </label>
              </Col>
              <Col xs={9} xl={5}>
                <input
                  onInput={handleInputChkThai}
                  type="text"
                  className="inp01 fontLight font-size03"
                  id="email"
                  placeholder="Email"
                  value={dataUser.email}
                  onChange={(event) =>
                    setDataUser({
                      ...dataUser,
                      email: event.target.value,
                    })
                  }
                  disabled={editId ? true : false}
                />
              </Col>
              <Col xs={3} xl={1} className="p-0">
                <label className="fontLight font-size03 colorBlack01">
                  Mobile <span className=' colorRed'>*</span>
                </label>
              </Col>
              <Col xs={9} xl={5}>
                <input
                  type="number"
                  className="inp01 fontLight font-size03"
                  id="tel"
                  placeholder="000000000"
                  value={dataUser.tel}
                  onChange={(event) =>
                    setDataUser({
                      ...dataUser,
                      tel: event.target.value,
                    })
                  }
                />
              </Col>
            </Row>
          </div>
          <Row className="ms-5 mt-4">
            <Col xs={1} className="p-0 d-flex justify-content-start me-4">
              <button
                className="btn-cancle01"
                onClick={() => handleClickCancel()}
              >
                CANCEL
              </button>
            </Col>
            <Col xs={1} className="p-0 d-flex justify-content-start">
              <button
                className="btn-save01"
                onClick={(e) => {
                  handleActiveBtn(editId);
                }}
              >
                SAVE
              </button>
            </Col>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AddEditUser;